import { BulkSendMessageResultItem } from '@commenda/api/chatRoom';
import { IServiceRequest } from '@commenda/types/src/service-request/types';

function sanitizeCsvCell(value: string): string {
  if (/^[=+\-@\t\r]/.test(value)) {
    return `'${  value}`;
  }
  return value;
}

export function downloadFailedCsv(
  failedResults: BulkSendMessageResultItem[],
  serviceRequests: IServiceRequest[],
  sentMessage: string
) {
  const headers = ['SR ID', 'Company ID', 'Company Name', 'Corporation ID', 'Corporation Name', 'Message', 'Error Message'];
  const rows = failedResults.map((result) => {
    const sr = serviceRequests.find((s) => s.id === result.serviceRequestId);
    return [
      result.serviceRequestId,
      String(sr?.companyId ?? ''),
      sr?.companyName ?? '',
      String(sr?.businessEntityId ?? ''),
      sr?.corporationName ?? '',
      sentMessage,
      result.error ?? 'Unknown error',
    ];
  });

  const csvContent = [headers, ...rows]
    .map((row) =>
      row.map((cell) => `"${sanitizeCsvCell(String(cell).replace(/"/g, '""'))}"`).join(',')
    )
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `failed-mass-messages-${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 100);
}
